import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { env } from '@/app/config/env';

interface AppState {
  appName: string;
  environment: string;
  isOnline: boolean;
  lastSyncedAt: string | null;
}

const initialState: AppState = {
  appName: env.APP_NAME,
  environment: env.APP_ENV,
  isOnline: navigator.onLine,
  lastSyncedAt: null,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setOnlineStatus: (state, action: PayloadAction<boolean>) => {
      state.isOnline = action.payload;
    },
    setLastSyncedAt: (state, action: PayloadAction<string>) => {
      state.lastSyncedAt = action.payload;
    },
  },
  selectors: {
    selectAppName: (state) => state.appName,
    selectEnvironment: (state) => state.environment,
    selectIsOnline: (state) => state.isOnline,
    selectLastSyncedAt: (state) => state.lastSyncedAt,
  },
});

export const { setOnlineStatus, setLastSyncedAt } = appSlice.actions;

export const {
  selectAppName,
  selectEnvironment,
  selectIsOnline,
  selectLastSyncedAt,
} = appSlice.selectors;

export default appSlice.reducer;
